import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

// Models
import { LicenseDetails } from '../models/license-details.model';

// Environments
import { environment } from '../../../environments/environment';


@Injectable({
  providedIn: 'root'
})
export class LicenseService {
  private readonly http = inject(HttpClient);

  getLicenseDetails() {
    return this.http.get<LicenseDetails>(`${environment.apiGatewayUrl}/ugc/api/v1/license/details`);
  }

  getApiKeyEnabled() {
    return this.http.get<{enabled: boolean}>(`${environment.apiGatewayUrl}/ugc/api/v1/api-key/enabled`);
  }

  setApiKeyEnabled(enabled: boolean) {
    return this.http.put(`${environment.apiGatewayUrl}/ugc/api/v1/api-key/enabled`, { enabled });
  }
}
